import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { getImageUrls } from '../utils/image';
import useDialogFocus from '../hooks/useDialogFocus';
import Icon from './Icon';
import './productIdentity.css';

export default function ProductImage({ product, src, alt, width = 48, height = 64, zoom = false, className = '', style, loading = 'lazy', ...props }) {
  const urls = getImageUrls(src ? { imageUrl: src, product } : product);
  const key = JSON.stringify(urls);
  const [failed, setFailed] = useState({ key, index: 0 });
  const [open, setOpen] = useState(false);
  const index = failed.key === key ? failed.index : 0;
  const image = urls[index];
  const title = alt ?? product?.productTitle ?? product?.product_title ?? product?.title ?? product?.product?.title ?? product?.orderItem?.product?.title ?? 'Товар';
  const dialog = useDialogFocus(open, () => setOpen(false));
  const dimensions = { width, height, ...style };
  const photo = image ? <img {...props} className={`product-photo ${className}`} src={image} alt={title} width={width} height={height} loading={loading} decoding="async" style={dimensions} onError={() => setFailed({ key, index: index + 1 })} />
    : <span className={`product-photo product-photo--missing ${className}`} role="img" aria-label={`${title}: фото не загружено`} title="Фото не загружено" style={dimensions}><Icon name="image" size={22} /><small>Нет фото</small></span>;
  return <>
    {zoom && image ? <button type="button" className="product-photo-zoom" aria-label={`Увеличить фото: ${title}`} onClick={event => { event.stopPropagation(); setOpen(true); }}>{photo}</button> : photo}
    {open && createPortal(<div className="product-photo-overlay">
      <button type="button" className="product-photo-backdrop" aria-label="Закрыть просмотр фото" tabIndex={-1} onClick={event => { event.stopPropagation(); setOpen(false); }} />
      <section ref={dialog} className="product-photo-dialog" role="dialog" aria-modal="true" aria-label={`Фото: ${title}`} tabIndex={-1} onClick={event => event.stopPropagation()}>
        <button type="button" className="product-photo-close" aria-label="Закрыть фото" onClick={() => setOpen(false)}><Icon name="close" /></button>
        <ProductImage product={product} src={image} alt={title} width="100%" height="100%" loading="eager" />
        <p>{title}</p>
      </section>
    </div>, document.body)}
  </>;
}
